import * as types from './mutations_type';

export const state = {
  modelDAta: {},
};

export const mutations = {
  [types.SET_MODEL_DATA]: (_, data) => {
    state.modelDAta = data;
  },
};



// WEBPACK FOOTER //
// ./src/modules/TaskEngine/_store/mutations.js